<template>
  <div
    v-if="contents && selectedCarouselItem !== null"
    class="screensaver"
    @click="onClick"
  >
    <!--v-carousel
      cycle
      width="100%"
      height="100%"
      hide-delimiter-background
      show-arrows-on-hover
      :show-arrows="false"
      hide-delimiters
    >
      <v-carousel-item
        v-for="(image, i) in images"
        :key="i"
        :src="image"
      />
    </v-carousel-->
    <v-carousel 
      v-model="selectedCarouselItem"
      :cycle="false"
      :show-arrows="false" 
      hide-delimiters
      height="100%"
    >
      <v-carousel-item
        v-for="(item, i) in contents"
        :key="i"
        v-html="item.content"
      />
    </v-carousel>

  </div>
</template>
<script>
export default {
  name: 'CustomCarousel',
  props: {
    onClick: {
      type: Function,
      required: true,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    contents: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    timer: null,
    selectedCarouselItem: null,
  }),
  watch: {
    dialog (v) {
      if (v) {
        this.selectedCarouselItem = 0
        this.handleInterval()
      } else {
        if (this.timer) clearTimeout(this.timer)
        this.selectedCarouselItem = null
      }
    },
  },
  mounted () {
    this.selectedCarouselItem = 0
    this.handleInterval()
  },
  methods: {
    handleInterval () {
      const content = this.contents[this.selectedCarouselItem]
      const duration = content ? content.duration * 1000 : 0
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.handleChangeContent()
      }, duration)
    },
    handleChangeContent () {
      this.selectedCarouselItem = this.selectedCarouselItem < this.contents.length-1 ? this.selectedCarouselItem + 1 : 0
      this.handleInterval () 
    },
  },
}
</script>
<style scoped>
.screensaver {
  height: calc(100vh);
  background-color: white;
}
</style>
